import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-subtitulo',
  templateUrl: './subtitulo.component.html',
  styleUrls: ['./subtitulo.component.scss']
})
export class SubtituloComponent implements OnInit {
  @Input() text: string = '';

  constructor() {}

  ngOnInit() {}
}
